<template>
	<o-tour :ref="setup._tourOrder">
		<o-tour-step
			title="Vue d'ensemble"
			hide-finish>
			<p>
				<b>Utilisateur régulier</b> de la plateforme ? Vous ne serez pas perdu, nos listes sont toujours les mêmes 😉
			</p>
			<div>
				<b>Novice</b> ? Aucune inquiétude, Armado est d'une simplicité enfantine !
			</div>
		</o-tour-step>

		<o-tour-step
			v-if="!setup.ui.onLayoutNavBottom"
			title="En-têtes"
			hide-finish
			:target="setup.orderListOrderBy.bind(setup)">
			<div>
				<p>
					Les listes peuvent être ordonnées grâce aux en-têtes.
				</p>
				<p>
					Vous souhaitez trier par <b>date de début de mission</b> ?
					<br> Aucun problème, un simple clic viendra appliquer le tri !
				</p>
				L'ordre d'affichage ne vous convient pas ? 🧐
				<br>
				Il suffit de cliquer une seconde fois et le tri est <b>inversé</b>.
			</div>
		</o-tour-step>

		<o-tour-step
			v-if="setup.canWrite"
			title="Actions"
			hide-finish
			target="order-add-button">
			<div>
				<p>
					Suivant vos <b>droits</b> et la gestion dans laquelle vous vous trouvez,
					vous aurez la possibilité d'effectuer une ou plusieurs actions.
				</p>
				Ici par exemple, vous pourrez créer une <b>nouvelle commande</b>
				<span v-if="setup.self.isAgency()">
					pour le compte d'une de vos
					entreprises utilisatrice !
				</span>
				<span v-else>
					à destination
					de votre agence d'emploi !
				</span>
			</div>
		</o-tour-step>

		<o-tour-step
			v-if="setup.hasData"
			title="Liste"
			size="lg"
			target="order-el-0">
			<div>
				<p>
					Une liste sur Armado est constituée de <b>20 éléments maximums</b> par page.
				</p>
				<p>
					Le contenu de ces éléments - <i>sticker*</i> - dépend forcément du <b>contexte</b> !
				</p>
				Ici par exemple :
				<ul>
					<li>
						La société <b>émettrice</b> de la commande et la société <b>destinatrice</b>.
						<br>
						La flèche
						<o-icon
							font-icon="icon-interface-arrows-bend-down-right-2"
							class="relation-arrow"/> permet de savoir qui a créé la commande et à destination de qui.
					</li>
					<li>
						La <b>qualification</b> demandée et le nombre d'intérimaires à pourvoir.
					</li>
					<li>
						Les <b>dates </b> de la mission.
					</li>
					<li>
						La <b>localisation</b> de la mission.
					</li>
					<li v-if="setup.self.isAgency()">
						Un <b>statut</b> de la commande, une indication de <b>criticité</b> ainsi que le nombre de <b>candidats positionnés</b> sur la mission,
						par rapport au nombre souhaité de candidat.
					</li>
					<li v-else>
						Un <b>statut</b> de la commande ainsi que le nombre de candidats <b>validés</b> par votre agence d'emploi.
					</li>
					<li>
						Au <b>survol de l'élément</b>, sous ces statuts, des actions possibles <b>selon vos droits</b>.
					</li>
				</ul>

				<p>
					Rien de bien compliqué, on vous l'avait dit 😉
				</p>

				<i>sticker* : le joli nom qu'Armado utilise pour parler d'un élément d'une liste</i> 😇
			</div>
		</o-tour-step>

		<o-tour-step
			v-else
			title="Liste">
			<p>
				Cette liste bien vide ne demande qu'à être remplie !
			</p>
			C'est <b>à vous</b> de jouer maintenant, vous pouvez terminer ce tuto
			et vous lancer dans la création d'une <b>nouvelle commande</b>
			<span v-if="setup.self.isAgency()">
				ou laissez vos clients vous adresser ses premières !
			</span>
			<span v-else>
				auprès de votre agence d'emploi !
			</span>
		</o-tour-step>
	</o-tour>
</template>

<script setup lang="ts">
import TourOrderSetupService from '@/setup/tour/TourOrderSetupService';
const setup = new TourOrderSetupService();
</script>
